import React from 'react'

export type ViewTransitionScope = 'main' | 'terminal' | 'background'

const ViewTransitionScopeContext =
  React.createContext<ViewTransitionScope>('main')

export function ViewTransitionScopeProvider({
  scope,
  children,
}: {
  scope: ViewTransitionScope
  children: React.ReactNode
}) {
  return (
    <ViewTransitionScopeContext.Provider value={scope}>
      {children}
    </ViewTransitionScopeContext.Provider>
  )
}

export function useViewTransitionScope(): ViewTransitionScope {
  return React.useContext(ViewTransitionScopeContext)
}
